import { render } from "./App.vue?vue&type=template&id=778bdbcb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=778bdbcb&lang=scss"

import exportComponent from "D:\\Work\\tatu\\tatu_25_5_24\\3.1源代码_25_4_3\\前端-源代码\\smart-battery-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__